import { isCorporateThemeSelector } from 'modules/app/appSlice';
import { allAvailableProjectsSelector, loadProjects } from 'modules/projects/projectsSlice';

import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';

import { getDistinctSdgs } from 'utils/project';

import BoxContent from '../BoxContent/BoxContent';
import BoxMain from '../BoxMain/BoxMain';

import SDGContent from './SDGContent';

interface SDGProps {
  biggerSlides?: boolean;
  animate?: boolean;
  short?: boolean;
  boxWidth?: BoxWidth;
}

const SDG: FC<SDGProps> = ({ biggerSlides, animate, short, boxWidth = 'lg' }) => {
  const { ready } = useTranslation('common');
  const { viewableItems: items, loading } = useSelector((state: RootState) => state.projects);
  const allAvailableProjects = useSelector(allAvailableProjectsSelector);
  const isCorporateTheme = useSelector(isCorporateThemeSelector);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!items.length && !loading) {
      dispatch(loadProjects());
    }
  }, []);

  const sdgs = getDistinctSdgs(isCorporateTheme ? allAvailableProjects : items);

  return (
    <BoxContent boxWidth={boxWidth} animate={animate} id="sdg-module" className="sdg-module">
      <BoxMain ready={!loading && ready} overlayHeight="420px" overlayType="sdg">
        <SDGContent biggerSlides={biggerSlides} sdgs={sdgs} short={short} />
      </BoxMain>
    </BoxContent>
  );
};

export default SDG;
